import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	actionTimeline: {
		id: 'software-board-settings-timeline.common.success-flag-with-timeline-link.action-timeline',
		defaultMessage: 'Go to timeline',
		description: 'Go to timeline flag action',
	},
});
